module.exports = __webpack_public_path__ + "static/media/CheckmarkSales.165dc8e9.svg";